import React from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import styled from '@emotion/styled';

const ACCENT = '#F43F60';

const CalendarWrapper = styled.div`
  background: #151414;
  border-radius: 16px;
  padding: 32px 24px 24px 24px;
  color: #fff;
  width: 100%;
  max-width: 900px;

  @media (max-width: 767px) {
    padding: 5px;
  }
  .react-calendar {
    background: transparent;
    border: none;
    color: #fff;
    font-family: 'Clash Grotesk', 'sans-serif';
    width: 100%;
  }
  .react-calendar__navigation {
    display: none;
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-size: 16px;
    color: #fff;
    font-weight: 400;
    letter-spacing: 0.02em;
    margin-bottom: 16px;
    abbr {
      text-decoration: none;
      cursor: default;
      font-family: 'Clash Grotesk', 'sans-serif';
    }
  }
  .react-calendar__tile {
    background: none;
    color: #fff;
    border-radius: 999px;
    font-size:16px;
    width: 64px;
    height: 48px;
    margin: 2px auto;
    transition: background 0.2s, color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Clash Grotesk', 'sans-serif';
    font-weight: 400;
    &:hover {
      background: rgba(244, 63, 96, 0.15);
      color: #fff;
    }
    
  @media (max-width: 767px) {
    width: 40px;
    height: 40px;
  }
  }
  .react-calendar__tile--active {
    background: ${ACCENT} !important;
    color: #fff !important;
    font-weight: 400;
    border-radius: 999px;
  }
  .react-calendar__tile--now {
    background: rgba(244, 63, 96, 0.2);
    color: #fff;
  }
  .react-calendar__tile:disabled {
    color: #444;
    background: none;
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const MonthYear = styled.div`
  font-size: 16px;
  color: #fff;
  font-family: 'Clash Grotesk', 'sans-serif';
  letter-spacing: 0.01em;
`;

const NavButton = styled.button`
  background: #fff;
  color: #181818;
  border: none;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  margin-left: 8px;
  margin-right: 8px;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: #ededed;
    color: ${ACCENT};
  }
`;

function getMonthYear(date) {
    return date?.toLocaleString('en-US', { month: 'long', year: 'numeric' });
}

const CustomCalendar = ({ value, onChange, ...props }) => {
    const [activeStartDate, setActiveStartDate] = React.useState(value || new Date());
    const calendarRef = React.useRef();

    const handlePrev = () => {
        const prev = new Date(activeStartDate);
        prev.setMonth(prev.getMonth() - 1);
        setActiveStartDate(prev);
    };
    const handleNext = () => {
        const next = new Date(activeStartDate);
        next.setMonth(next.getMonth() + 1);
        setActiveStartDate(next);
    };

    return (
        <CalendarWrapper >
            <HeaderRow>
                <MonthYear>{getMonthYear(activeStartDate)}</MonthYear>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <NavButton aria-label="Previous month" onClick={handlePrev}>
                        <span style={{ fontSize: '2rem', fontWeight: 500 }}>&#x2039;</span>
                    </NavButton>
                    <NavButton aria-label="Next month" onClick={handleNext}>
                        <span style={{ fontSize: '2rem', fontWeight: 500 }}>&#x203A;</span>
                    </NavButton>
                </div>
            </HeaderRow>
            <Calendar
                ref={calendarRef}
                value={value}
                onChange={onChange}
                calendarType="iso8601"
                activeStartDate={activeStartDate}
                onActiveStartDateChange={({ activeStartDate }) => setActiveStartDate(activeStartDate)}
                {...props}
            />
        </CalendarWrapper>
    );
};

export default CustomCalendar; 